import counter from '../lib/counter.js';

// whenever a search arrives, update the text content of the element with the
// hit count.
export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('filter-and-search-changed').subscribe(updateCount);
        let lastCount = Number(ele.getAttribute('data-count'));
        const prop = ele.getAttribute('data-counter-prop');
        const format = function(number) {
            // http://stackoverflow.com/a/2901298
            return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, '$&\u00A0');
        };
        let c;
        function updateCount(result) {
            setHeight();
            if (typeof result[prop] != 'number') {
                ele.textContent = '';
                return;
            }
            if (c) {
                c.abort();
            }
            c = counter(
                {
                    start: lastCount,
                    end: result[prop],
                },
                count => {
                    ele.textContent = format(count);
                }
            );
            ele.setAttribute('data-count', result[prop]);
            lastCount = result[prop];
        }
        // This is important to contain layout
        function setHeight() {
            const container = ele.closest('.current-hit-count');
            if (container && !container.style.height) {
                window.requestAnimationFrame(() => {
                    container.style.height = `${container.offsetHeight}px`;
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/counter.js